/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Label_PhoneInputs */

const vi_receipt_label_phone = /** @type {(inputs: Receipt_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số Điện Thoại`)
};

/**

* @param {Receipt_Label_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_label_phone = /** @type {((inputs?: Receipt_Label_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Label_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_label_phone(inputs)
});